import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-hummer2-icon',
  templateUrl: './tools-hummer2.component.html'
})
export class ToolsHummer2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
